import { render, staticRenderFns } from "./PageNotice.vue?vue&type=template&id=95f42f3a&scoped=true"
import script from "./PageNotice.vue?vue&type=script&lang=js"
export * from "./PageNotice.vue?vue&type=script&lang=js"
import style0 from "./PageNotice.vue?vue&type=style&index=0&id=95f42f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f42f3a",
  null
  
)

export default component.exports